<header class="site-header">
  <div class="site-header__bar">
    <div class="site-header__container">
      <!-- Logo -->
      <a class="site-header__brand" routerLink="/" [attr.aria-label]="'header.aria.home' | translate">
        <img src="/logo-cluster.png" alt="Clúster TIC Galicia" />
      </a>

      <!-- Navegación desktop -->
      <nav class="site-header__desktop-nav" [attr.aria-label]="'header.aria.main_nav' | translate">
        @for (item of navItems(); track item.label + item.route) {
          <a
            class="site-header__nav-link"
            [routerLink]="item.route"
            routerLinkActive="site-header__nav-link--active"
            [routerLinkActiveOptions]="{ exact: !!item.exact }"
          >
            <span>{{ item.label | translate }}</span>
            @if (item.route === '/mensaxeria' && unreadBadge()) {
              <span class="site-header__badge">{{ unreadBadge() }}</span>
            }
          </a>
        }
      </nav>

      <!-- Acciones usuario desktop -->
      <div class="site-header__desktop-user">
        <app-language-selector></app-language-selector>

        @if (!isAuthenticated()) {
          <button class="site-header__login-btn" type="button" (click)="login()">
            {{ 'header.auth.login' | translate }}
          </button>
        }

        @if (isAuthenticated()) {
          <div class="site-header__user-menu">
            <button
              class="site-header__avatar"
              type="button"
              (click)="toggleUserMenu()"
              [attr.aria-label]="'header.aria.avatar' | translate"
              [style.background-color]="showPhoto() ? 'transparent' : avatarColor()"
            >
              @if (showPhoto()) {
                <img class="site-header__avatar-img" [src]="photoUrl() ?? ''" alt="" />
              } @else {
                <span>{{ userInitials() }}</span>
              }
            </button>

            @if (isUserMenuOpen) {
              <div class="site-header__dropdown">
                <button type="button" (click)="navigateToProfile()">
                  {{ 'header.nav.perfil' | translate }}
                </button>
                <button type="button" (click)="logout()">
                  {{ 'header.auth.logout' | translate }}
                </button>
              </div>
            }
          </div>
        }
      </div>

      <!-- Acciones móvil -->
      <div class="site-header__mobile-actions">
        <button
          class="site-header__menu-button"
          type="button"
          (click)="toggleMobileMenu()"
          [attr.aria-expanded]="isMobileMenuOpen"
          [attr.aria-label]="isMobileMenuOpen ? ('header.aria.close_menu' | translate) : ('header.aria.open_menu' | translate)"
        >
          <span [class.site-header__menu-button--open]="isMobileMenuOpen"></span>
          <span [class.site-header__menu-button--open]="isMobileMenuOpen"></span>
          <span [class.site-header__menu-button--open]="isMobileMenuOpen"></span>
        </button>
      </div>
    </div>
  </div>

  <!-- Navegación móvil drawer -->
  @if (isMobileMenuOpen) {
    <nav class="site-header__mobile-nav" [attr.aria-label]="'header.aria.mobile_nav' | translate">
      <div class="site-header__mobile-language">
        <app-language-selector></app-language-selector>
      </div>

      @for (item of navItems(); track item.label + item.route) {
        <a
          class="site-header__mobile-link"
          [routerLink]="item.route"
          routerLinkActive="site-header__mobile-link--active"
          [routerLinkActiveOptions]="{ exact: !!item.exact }"
          (click)="closeMobileMenu()"
        >
          {{ item.label | translate }}
          @if (item.route === '/mensaxeria' && unreadBadge()) {
            <span class="site-header__mobile-badge">{{ unreadBadge() }}</span>
          }
        </a>
      }

      @if (!isAuthenticated()) {
        <a class="site-header__mobile-link site-header__mobile-link--access" href="javascript:void(0)" (click)="login(); closeMobileMenu()">
          {{ 'header.auth.login' | translate }}
        </a>
      }

      @if (isAuthenticated()) {
        <a class="site-header__mobile-link" href="javascript:void(0)" (click)="navigateToProfile(); closeMobileMenu()">
          {{ 'header.nav.perfil' | translate }}
        </a>
        <a class="site-header__mobile-link site-header__mobile-link--access" href="javascript:void(0)" (click)="logout(); closeMobileMenu()">
          {{ 'header.auth.logout' | translate }}
        </a>
      }
    </nav>
  }
</header>
